import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getInteractiveState } from '../../interactiveState/getInteractiveState.js';
import { useAdsStylesContext } from './useAdsStylesContext.js';
import { mapAdsStyles } from '../mapAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useAdsStyles = function useAdsStyles() {
  var adsStylesContext = useAdsStylesContext();
  return {
    adsStylesContext: adsStylesContext,
    mapAdsStyles: function mapAdsStyles$1(input) {
      return mapAdsStyles(input, adsStylesContext);
    },
    getInteractiveState: function getInteractiveState$1(input) {
      return getInteractiveState(_objectSpread({
        intent: adsStylesContext.intent
      }, input));
    }
  };
};

export { useAdsStyles };
//# sourceMappingURL=useAdsStyles.js.map
